<template>
  <collapse-box :default-expand="true">

    <div id="common-questions">
      <!-- 标题 -->
      <div class="header">
        <div class="title">常见问题</div>
        <div class="search-input-box">
          <div class="search-input">
            <input
              v-on:keyup.enter="questionSearch()"
              v-model="questionSearchParam.keyword"
              @input="questionInputValueChange()"
              placeholder="请输入搜索关键词"
            />
            <img
              alt="重置"
              class="common-question-reset-button"
              src="../../../../assets/imgs/QA/search_delete.png"
              v-show="questionSearchParam.keyword"
              @click="resetQuestionSearch()"
            />
          </div>
          <div class="button-box">
            <el-button
              class="btn primary"
              :disabled="!questionSearchParam.keyword"
              @click="questionSearch()"
            >搜索</el-button>
            <el-button class="btn" @click="askQuestion()">我要提问</el-button>
          </div>
        </div>
      </div>

      <!-- 问题 tab -->
      <div
        class="question-tab"
        v-show="commongOrSearch && (questionListData && questionListData.length !== 0)"
      >
        <div class="question-header">
          <div class="nav-box">
            <div class="nav-item" :class="{active: questionActiveTab === 0}" id="question-nav-item-0" @click="questionTabSwitch(0)">热门问题</div>
            <div class="nav-item" :class="{active: questionActiveTab === 1}" id="question-nav-item-1" @click="questionTabSwitch(1)">最新提问</div>
            <div class="nav-bottom-bar" :style="{left: navBottomBarLeft + 'px'}"></div>
          </div>
          <collapse-btn></collapse-btn>
        </div>
        <collapse-content>
          <div class="question-content">
            <ul v-for="(item, index) in questionListData" :key="index">
              <li>
                <h4 @click="jumpQuestionDetail(item.qa_question_id)">{{item.question}}</h4>
                <p v-if="item.answer" @click="jumpQuestionDetail(item.qa_question_id)">{{item.answer}}</p>
                <div class="question-bottom">
                  <div class="left-box">
                    <span class="question-time">{{item.create_time}}</span>
                    <div class="question-like" :class="{is_like: item.is_like === 1}" @click="likeQA(item.qa_question_id)">
                      <img
                        src="../../../../assets/imgs/product-detail/list_like.png"
                        alt="点赞"
                        v-show="item.is_like === 0"
                      />
                      <img
                        src="../../../../assets/imgs/product-detail/list_liked.png"
                        alt="点赞"
                        v-show="item.is_like === 1"
                      />
                      <span v-show="item.like_count">{{item.like_count}}</span>
                    </div>
                  </div>
                  <router-link
                    target="_blank"
                    class="view-question-detail"
                    :to="{ name: 'questionDetail', params: { id: item.qa_question_id } }"
                  >查看详情</router-link>

                </div>
              </li>
            </ul>
          </div>

          <!-- 常见问题列表翻页 -->
          <el-pagination
            class="question-list-pagination"
            @size-change="commonQuestionListSearch()"
            @current-change="commonQuestionListSearch()"
            :current-page.sync="commonQuestionList.page"
            :page-size="20"
            layout="prev, pager, next, jumper"
            v-show="questionListNum > 20"
            :total="questionListNum"
          ></el-pagination>
        </collapse-content>

      </div>

      <!-- 搜索问题列表 -->
      <div
        class="question-tab"
        v-show="!commongOrSearch && (questionListData && questionListData.length !== 0)"
      >
        <ul v-for="(item, index) in questionSearchData" :key="index">
          <li>
            <h4 @click="jumpQuestionDetail(item.qa_question_id)">{{item.question}}</h4>
            <p v-if="item.answer" @click="jumpQuestionDetail(item.qa_question_id)">{{item.answer}}</p>
            <div class="question-bottom">
              <div class="left-box">
                <span class="question-time">{{item.create_time}}</span>
                <div class="question-like" @click="likeQA(item.qa_question_id)">
                  <img src="../../../../assets/imgs/QA/list_like.png" alt="点赞" v-show="item.is_like === 0" />
                  <img src="../../../../assets/imgs/QA/list_liked.png" alt="点赞" v-show="item.is_like === 1" />
                  <span v-show="item.like_count">{{item.like_count}}</span>
                </div>
              </div>
              <router-link
                target="_blank"
                class="view-question-detail"
                :to="{ name: 'questionDetail', params: { id: item.qa_question_id } }"
              >查看详情</router-link>
            </div>
          </li>
        </ul>

        <!-- 搜索结果翻页 -->
        <el-pagination
          class="question-list-pagination"
          @size-change="questionSearch()"
          @current-change="questionSearch()"
          :current-page.sync="questionSearchParam.page"
          :page-size="20"
          layout="prev, pager, next, jumper"
          v-show="questionSearchNum > 20"
          :total="questionSearchNum"
        ></el-pagination>
      </div>

      <!-- 没有问题 -->
      <div
        class="qa-no-question"
        v-show="(commongOrSearch && questionListData && questionListData.length === 0)
                || (!commongOrSearch && questionSearchData && questionSearchData.length === 0)">
        <img src="../../../../assets/imgs/QA/answer_none.png" alt="暂无回答" />
        <p>暂时没有相关问题，快来提问吧！</p>
      </div>

      <!-- 我要提问弹窗 -->
      <ask-question
        :open="askQuestionModal"
        :country-id="product.visa_country_id"
        :country-name="product.visa_country_name"
        @updateQuestionList="commonQuestionListSearch()"
        @modalClose="askQuestionModal = false"
      ></ask-question>
    </div>
  </collapse-box>
</template>

<script>
import { mapMutations } from 'vuex';
import askQuestion from '@/components/product/ask-question';
import Http from '../../../../libs/http';
import User from '../../../../libs/user';
import CollapseBox from '../../../../components/common/collapse/collapse-box';
import CollapseBtn from '../../../../components/common/collapse/collapse-btn';
import CollapseContent from '../../../../components/common/collapse/collapse-content';

export default {
  name: 'common-questions',
  components: {
    askQuestion,
    CollapseBox,
    CollapseBtn,
    CollapseContent,
  },
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    country: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      // 常见问题列表对象
      commonQuestionList: {
        peer_account_id: User.peer_account_id,
        visa_country: '',
        condition: 'hot',
        page: 1,
      },
      // 问题搜索对象
      questionSearchParam: {
        peer_account_id: User.peer_account_id,
        keyword: '',
        page: 1,
        insure_search: 1, // 官网这里传固定值 1 即可
      },
      questionActiveTab: 0, // 问题切换 tab
      navBottomBarLeft: 0,

      askQuestionModal: false, // 我要提问弹窗
      questionListData: null, // 常见问题列表数据
      questionListNum: 0, // 常见问题列表数量
      questionSearchData: null, // 搜索问题数据
      questionSearchNum: 0, // 搜索问题数量
      commongOrSearch: true, // 显示常见问题列表还是搜索问题列表
    };
  },
  computed: {

  },
  methods: {

    ...mapMutations(['SHOW_LOGIN_BOX']),

    computedNavBottomBarLeft() {
      let left = 0;
      const navItemEl = document.querySelector(`#question-nav-item-${this.questionActiveTab}`);
      if (!navItemEl) return 0;
      left = navItemEl.offsetLeft + navItemEl.offsetWidth / 2 - 16;
      this.navBottomBarLeft = left;
    },

    // 常见问题搜索
    questionSearch() {
      if (this.questionSearchParam.page !== 1) {
        this.questionSearchParam.insure_search = 0;
      }
      this.questionSearchParam.country = this.country;
      Http.post('/sys/qa_search', this.questionSearchParam).then((data) => {
        this.questionSearchData = data.qa;
        this.questionSearchNum = data.total_count;

        this.commongOrSearch = false;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 常见问题列表
    commonQuestionListSearch() {
      this.commonQuestionList.visa_country = this.country;
      if (!this.commonQuestionList.peer_account_id) {
        delete this.commonQuestionList.peer_account_id;
      }
      return Http.post('/sys/qa_question_brief_query', this.commonQuestionList).then((data) => {
        this.questionListData = data.page_data;
        this.questionListNum = data.total_count;
        this.$emit('getQaCount', data.total_count);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 热门问题、最新问题 tab 切换
    questionTabSwitch(index) {
      this.questionActiveTab = index;
      this.computedNavBottomBarLeft();

      this.commonQuestionList.page = 1;
      if (this.questionActiveTab === 0) {
        this.commonQuestionList.condition = 'hot';
      } else if (this.questionActiveTab === 1) {
        this.commonQuestionList.condition = 'time';
      }
      this.commonQuestionListSearch();
    },

    // 重置搜索框（清空搜索框）
    resetQuestionSearch() {
      this.questionSearchParam.keyword = '';
      this.commongOrSearch = true;
    },

    // 更改内容清空了输入框的内容时也需要进行重置
    questionInputValueChange() {
      if (!this.questionSearchParam.keyword) {
        this.resetQuestionSearch();
      }
    },

    // 我要提问
    askQuestion() {

      // 如果没有登录，则跳转到登录页面
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_ask_question' });
        return;
      }

      // 打开提问弹窗
      this.askQuestionModal = true;
    },

    // 点赞操作或取消点赞操作
    likeQA(id) {

      // 如果没有登录，则跳转到登录页面
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_question_like' });
        return;
      }

      Http.post('/qa_question_like', {
        qa_question_id: id,
      }).then((data) => {
        // 重新查询接口（排序可能会变）
        // this.commonQuestionListSearch();
        // 直接修改本地数据
        // 常见问题类别数据
        this.questionListData.forEach((el) => {
          if (el.qa_question_id === id) {
            el.like_count = data.like_count;
            el.is_like = data.is_like;
          }
        });

        // 搜索问题列表数据
        this.questionSearchData && this.questionSearchData.forEach((el) => {
          if (el.qa_question_id === id) {
            el.like_count = data.like_count;
            el.is_like = data.is_like;
          }
        });
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 点击问题标题、答案跳到问题详情页
    jumpQuestionDetail(qa_question_id) {
      const jumpPath = this.$router.resolve({ name: 'questionDetail', params: { id: qa_question_id } });
      window.open(jumpPath.href, '_blank');
    },
  },
  watch: {
    product(newVal) {
      if (newVal.visa_product_id) {
        this.questionTabSwitch(0);
        this.resetQuestionSearch();
        this.commonQuestionListSearch().then(() => {
          this.computedNavBottomBarLeft();
        });
      }
    },
  },
  created() {
    this.commonQuestionListSearch().then(() => {
      this.computedNavBottomBarLeft();
    });
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/less/variable";

#common-questions {
  box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
  background: #fff;
  border-radius:2px;
  margin-top: 12px;
  .header{
    padding: 16px;
    display: flex;
    align-items: center;
    .title{
      flex-grow: 1;
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
      position: relative;
      z-index: 1;
      &::after{
        content: "";
        position: absolute;
        left: 0;
        bottom: -2px;
        z-index: -1;
        width:48px;
        height:6px;
        background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,1) 100%);
        opacity:0.6;
      }
    }
    .search-input-box{
      flex-shrink: 0;
      display: flex;
      .search-input{
        width: 277px;
        height: 32px;
        padding-left: 36px;
        margin-right: 8px;
        border: 1px solid #DEE2E6;
        border-radius: 2px;
        background: url("../../../../assets/imgs/product-detail/icon-search-input.png") no-repeat 12px center / 16px 16px;
        position: relative;
        input {
          width: 100%;
          height: 100%;
          border-radius: 2px;
          border: none;
          padding: 0;
          outline: none;
          font-size: 12px;
          color: #2F333D;
          caret-color: #5e9be1;
          &::-webkit-input-placeholder{
            color: #C9CDD1;
          }
        }
        .common-question-reset-button{
          position: absolute;
          top: 50%;
          right: 5px;
          transform: translateY(-50%);
          cursor: pointer;
          width: 16px;
          :hover {
            opacity: 0.8;
          }
        }
      }
      .button-box{
        display: flex;
        align-items: center;
        .btn{
          width:72px;
          height:32px;
          border-radius:2px;
          font-size: 12px;
          line-height: 1;
          border: 1px solid #599FFF;
          color: #599FFF;
          display: flex;
          align-items: center;
          justify-content: center;
          outline: none;
          &.primary{
            background: #599FFF;
            color: #fff;
            &.is-disabled{
              background: #BCD8FF;
              border: 1px solid #BCD8FF;
            }
          }

        }
        .btn+.btn{
          margin-left: 8px;
        }
      }
    }
  }

  .question-tab {
    padding: 0;

    .question-header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 16px;
      border-bottom: 1px solid #E9EEF2;
      .nav-box{
        height: 44px;
        display: flex;
        position: relative;
        padding: 0 16px;
        .nav-item{
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #91999F;
          margin-right: 32px;
          cursor: pointer;
          &.active{
            font-weight: 600;
            color: #599FFF;
          }
        }
        .nav-bottom-bar{
          width:32px;
          height:3px;
          background:linear-gradient(90deg,rgba(31,136,255,1) 0%,rgba(138,192,255,1) 100%);
          border-radius:2px 2px 0px 0px;
          position: absolute;
          bottom: 0;
          left: 0;
          transition: 0.15s all;
        }
      }
    }


    ul {
      padding-bottom: 16px;
      li {
        padding: 16px 16px 0 54px;
        position: relative;
        &::after{
          content: "";
          position: absolute;
          left: 18px;
          top: 16px;
          width: 30px;
          height: 31px;
          background: url("../../../../assets/imgs/product-detail/list-question.png") no-repeat center / 100% 100%;
        }

        h4 {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          color: #2F333D;
          margin-bottom: 12px;
          cursor: pointer;
        }
        h4:hover {
          color: #5e9be1;
        }
        p {
          font-size: 14px;
          font-weight: normal;
          line-height: 26px;
          color: #5F666E;
          margin-bottom: 12px;
          cursor: pointer;

          /* 让文本内容只显示两行，超出部分隐藏，结尾省略号 */
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        p:hover {
          color: #777777;
        }
        .question-bottom {
          display: flex;
          align-items: center;
          line-height: 1;
          justify-content: space-between;
          padding-bottom: 16px;
          border-bottom: 1px solid #E9EEF2;
          .left-box {
            font-size: 12px;
            display: flex;
            align-items: center;
            .question-time {
              color: #91999F;
            }
            .question-like {
              display: inline-flex;
              align-items: center;
              color: #91999F;
              padding-left: 12px;
              min-width: 45px;
              cursor: pointer;
              &.is_like{
                color: #599FFF;
              }
              img {
                width: 16px;
                height: 16px;
                margin-right: 2px;
              }
            }
          }
          .view-question-detail {
            font-size: 14px;
            color: #599FFF;
            &:hover {
              opacity: 0.8;
            }
          }

        }
      }
    }
    .question-list-pagination {
      padding-bottom: 16px;
      display: flex;
      justify-content: center;
      color: #aaa;
    }
  }
  .qa-no-question {
    margin: 80px auto 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    line-height: 54px;
    color: #6f6f6f;
    img {
      width: 96px;
      height: 90px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/common-questions.vue